module.exports = __webpack_public_path__ + "media/components/shared/header/static/search_icon-4513bd5b7cff4226a761c0cc5bb6f361.svg";